import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { ReactComponent as MobileDeviceIcon } from '../../../assets/icons/mobile-device.svg';
import TooltipComponent from '../../../components/common/bootstrap-component/tooltip-component';
import usePageTranslation from '../../../hooks/ui/usePageTranslation';
import { getTranslatedTextOrDefault } from '../../../util/util';

import { useMobilePreview } from '../hooks/use-mobile-preview';
import styles from './mobile-preview-toggle.module.scss';

export function MobilePreviewToggle() {
  const { isMobilePreview, toggle } = useMobilePreview();
  const { pathname, search } = useLocation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const wasMobilePreview = useRef(false);
  const PageTranslation = usePageTranslation();
  const translations = Array.isArray(PageTranslation) ? PageTranslation : [];
  const openLabel = getTranslatedTextOrDefault(
    'mobilePreview.open.tooltip',
    translations,
    'Preview this page on a mobile device',
  );
  const closeLabel = getTranslatedTextOrDefault(
    'mobilePreview.close.tooltip',
    translations,
    'Return to normal view',
  );
  const label = isMobilePreview ? closeLabel : openLabel;

  useLayoutEffect(() => {
    const button = buttonRef.current;
    if (wasMobilePreview.current && !isMobilePreview) {
      button?.focus();
    }
    wasMobilePreview.current = isMobilePreview;
  }, [isMobilePreview]);

  useLayoutEffect(() => {
    const button = buttonRef.current;
    if (button && document.activeElement === button) {
      button.blur();
    }
  }, [pathname, search]);

  return (
    <div className={styles.slot}>
      <TooltipComponent title={label} placement="top">
        <button
          ref={buttonRef}
          type="button"
          className={`btn btn-light rounded-circle shadow ${styles.toggle}${isMobilePreview ? ' active' : ''}`}
          aria-label={label}
          aria-pressed={isMobilePreview}
          data-testid="mobile-preview-toggle"
          onClick={toggle}
        >
          <MobileDeviceIcon className="bc-icon" aria-hidden="true" />
        </button>
      </TooltipComponent>
    </div>
  );
}
